import React, { useContext } from 'react';
import { GridDate as GridDateBase } from 'components/Grid';
import { CompGroupsContext } from 'context';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

const GridDate = ({ cell }: { cell: ICell }) => {
  const { onCellsChanged } = useContext(CompGroupsContext);

  const handleOnChange = (date: string) => {
    onCellsChanged?.([{ cell, value: date }]);
  };

  const { value, readOnly, disabled } = cell;

  return (
    <GridDateBase
      value={value as string}
      readOnly={readOnly}
      disabled={disabled}
      onCellsChanged={handleOnChange}
      cell={cell}
    />
  );
};

export default GridDate;
